import gql from "graphql-tag";

export const MY_TIMESHEET_CLIENTS_SUBSCRIPTION = gql`
  subscription MySheetClientsSubscription {
    MySheetClientsSubscription
  }
`;
